<template>
  <div class="card mt-3" v-if="data.length > 0">
    <div class="card-body">
      <div class="mb-2" :class="$style.textDivider">
        <h4
          class="font-size-16 font-weight-bold"
          :class="$style.textDividerContent"
        >
          Documentação Pendente
        </h4>
      </div>
      <div class="mb-4">
        <a-table
          :columns="columns"
          :dataSource="data"
          :pagination="false"
          :class="$style.table"
        >
          <template slot="action">
            <span class="fa fa-times-circle text-danger" />
          </template>

        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import { get as _get, debounce as _debounce } from "lodash";
import { MerchantsResource } from "@/resources/Merchants.resource.js";
const columns = [
  {
    title: "Documento",
    dataIndex: "merchantFileType",
  },
  {
    title: "Documento Substituto",
    dataIndex: "merchantFileTypeSubstitutive",
  },
  {
    title: "Status",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  props: {
    outdateParent: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data: function () {
    return {
      columns,
      idMerchant: _get(this.idMerchant, 0),
      data: [],
    };
  },
  methods: {
    getContent() {
      this.loading = true;
      var query = { idMerchant: this.idMerchant };
      MerchantsResource.getPendingFilesByMerchant(query)
        .then((result) => {
          try {
            this.data = result.data.payload;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        })
        .catch((e) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    outdateParent: function (newValue, oldValue) {
      if (newValue) {
        this.getContent();
      }
    },
  },
  mounted() {
    if (this.$route.params.id > 0) {
      this.idMerchant = this.$route.params.id;
      this.getContent();
    }
  },
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
